<template>
<div class="w-full">
  <Back/>
    <div class="flex items-center justify-between py-5">
        <span  class="">Kelas {{classroom?.name}}</span>

          <router-link :to="'/classroom/' + classroomId + '/webinar-record/add'" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-yellow-500 hover:bg-yellow-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                    Tambah Rekaman Webinar
                     </router-link>


    </div>
     <DataTable
              :value="webinarRecordList"
              :paginator="true"
              :rows="10"
              dataKey="id"
              :rowHover="true"
              filterDisplay="menu"
              v-model:filters="filters"
              :loading="isLoadingWebinarRecord"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :rowsPerPageOptions="[10, 25, 50]"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              responsiveLayout="scroll"
               class="p-datatable-sm font-sans text-sm"
            >
              <template #header>
                <div class="flex items-center justify-between">
                  <h5 class="p-m-0">List Video</h5>
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      v-model="filters['global'].value"
                      placeholder="Keyword Search"
                    />
                  </span>
                </div>
              </template>
              <template #empty>
                No Data found.
              </template>
              <template #loading>
                Loading webinar data. Please wait.
              </template>
              <Column field="id" header="ID" sortable></Column>
              <Column field="link" header="Video" sortable>
                    <template #body="{data}">
                        <div v-safe-html="data.link">

                        </div>
                    </template>
              </Column>
              <!-- <Column field="description" header="Deskripsi" sortable></Column> -->
              <Column field="classroom.name" header="Kelas" sortable></Column>

              <Column field="id" header="Aksi">
                <template #body="{data}">
                    <router-link :to="'/classroom/' + classroomId + '/webinar-record/'+ data.id + '/edit'" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-yellow-500 hover:bg-yellow-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                    Edit
                     </router-link>
                    <a @click.prevent="deleteData(data.id)" type="button" class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                        Hapus
                    </a>
                  
                  
                </template>
              </Column>
            </DataTable>

        
    <Toast />
</div>
 
</template>
<script>
import {
    FilterMatchMode
} from 'primevue/api'
import Back from '@/layout/Component/Back'
import {
    mapActions,
    mapGetters
} from 'vuex'

export default {

    components: {
        Back
    },
    data() {
        return {
            title: 'Daftar Materi Video',
            // loading: false,
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
            },
            classroomId: 0,
            items: []
        }
    },
    created() {
        this.classroomId = this.$route.params.id
        if (this.classroomId && (this.classroom?.id != this.classroomId)) {
            this.getClassroomDetail()
        }
        if ((this.webinarRecordList?.length == 0)|| (this.savedIdClassroomWebinarRecord != this.classroomId)) {
            this.fetchAllWebinarRecords(this.classroomId)
        }
    },
    computed: {
        ...mapGetters(["classroom", "webinarRecordList", "isSuccessWebinarRecord", "isLoadingWebinarRecord", "messageWebinarRecord", "savedIdClassroomWebinarRecord"]),
    },
    methods: {
        ...mapActions(["fetchDetailClassroom", "fetchAllWebinarRecords", "deleteWebinarRecord"]),
        async getClassroomDetail() {
            await this.fetchDetailClassroom(this.classroomId)
        },
        async deleteData(id) {
            const confimation = confirm("Apakah anda yakin ingin menghapus?")
            // console.log(confimation)
            if (confimation) {
                // console.log(id)
                await this.deleteWebinarRecord(id)
                // console.log(this.isSuccessWebinarRecord)
                if (this.isSuccessWebinarRecord) {
                    // console.log("here")

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: this.messageWebinarRecord,
                        life: 1000
                    })
                    setTimeout(() => this.fetchAllWebinarRecords(this.classroomId), 1000)
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Failed',
                        detail: this.messageWebinarRecord
                    })
                }
            }
        }
    }
}
</script>
